module.exports = __webpack_public_path__ + "img/icon-error-404.a9dad29e.svg";